import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";

import { LocationForOrigin } from "./LocationForOrigin";

/**
 * @returns true if the utm_medium is social
 */
export const isComingFromSocial = (location: LocationForOrigin): boolean => {
  const utmMedium = parseQueryParams(location?.search ?? "").get("utm_medium");
  return utmMedium === "social";
};
